import * as angular from 'angular';

class NfcHistoryItem {
    static $inject = ['$translate'];

    constructor(
        protected $translate: angular.translate.ITranslateService,
    ) { }
}

angular.module('naut').component('nfcHistoryItem', {
    template: require('./history-item.component.html'),
    controller: NfcHistoryItem,
    controllerAs: 'ctrl',
    bindings: {
        'status': '<',
        'stores': '<',
        'items': '<',
        'assigned': '<',
        'date': '<',
    },
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/history/history-item/history-item.component.ts